export default __webpack_public_path__ + "media/right-arrows 1.d60fa11d.svg";